import { Navigate, Route, Routes } from 'react-router-dom';

import TermsAndConditionsModal from 'components/PopUps/TermsAndConditionsModal';

import { lazyWithRetry } from 'utils/lazy-with-retry';

import useTokenRefresher from 'hooks/useTokenRefresher';

const QuestionnaireForm = lazyWithRetry(() => import('components/QuestionnaireForm/QuestionnaireForm'));
const DashboardPage = lazyWithRetry(() => import('components/pages/Dashboard/DashboardPage'));
const LogoutPage = lazyWithRetry(() => import('components/pages/LogoutPage/LogoutPage'));
const SignUpPage = lazyWithRetry(() => import('components/pages/SignUpPage/SignUpPage'));

const TempUserApp = () => {
    useTokenRefresher();
    return (
        <>
            <TermsAndConditionsModal />
            <Routes>
                <Route path="/document/:questionnaireType/:stateCode/:qInstanceId" element={<QuestionnaireForm />} />
                <Route
                    path="/document/:questionnaireType/:stateCode/:qInstanceId/:section"
                    element={<QuestionnaireForm />}
                />
                <Route path="/signup-after-assessment" element={<SignUpPage afterAssessment={true} />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/dashboard/*" element={<DashboardPage />} />
                <Route path="/*" element={<Navigate to="/dashboard" />} />
            </Routes>
        </>
    );
};

export default TempUserApp;
